export function getSmartRenameDisplay(oldPath: string, newPath: string): string {
  const oldParts = oldPath.split('/');
  const newParts = newPath.split('/');

  // Find the first differing part from the end
  let oldDiffIndex = oldParts.length - 1;
  let newDiffIndex = newParts.length - 1;

  while (oldDiffIndex >= 0 && newDiffIndex >= 0) {
    if (oldParts[oldDiffIndex] !== newParts[newDiffIndex]) {
      break;
    }
    oldDiffIndex--;
    newDiffIndex--;
  }

  // If paths are identical (shouldn't happen), return the full path
  if (oldDiffIndex < 0 && newDiffIndex < 0) {
    return newPath;
  }

  // Include one directory above the difference if it exists
  const contextIndex = Math.max(0, oldDiffIndex - 1);
  const newContextIndex = Math.max(0, newDiffIndex - 1);

  // Extract the differing parts with context
  const oldUnique = oldParts.slice(contextIndex).join('/');
  const newUnique = newParts.slice(newContextIndex).join('/');

  // Add .../ to indicate truncation for both paths if needed
  const prefix = contextIndex > 0 ? '.../' : '';
  const newPrefix = newContextIndex > 0 ? '.../' : '';

  return `${prefix}${oldUnique} → ${newPrefix}${newUnique}`;
}

// Utility: determine if a file is a pure rename (no additions / deletions)
export const isPureRename = (
  status: string,
  additions: number | undefined,
  deletions: number | undefined,
): boolean => status === 'renamed' && (additions ?? 0) === 0 && (deletions ?? 0) === 0;
